<script>
import ChangesView from '@/views/PassportsList/components/ChangesView/index.vue'

import { LkPassportApi } from '@/api/resources'

export default {
  extends: ChangesView,
  methods: {
    async onLoadData() {
      this.isLoading = true
      try {
        const api = new LkPassportApi()
        const data = await api.history(this.passportId, {
          action_type: this.actionTypes,
        })
        if (this.actionTypes.includes('activate') || this.actionTypes.includes('status_updated')) {
          this.data.data = data
        } else {
          this.data.data = data.filter((obj) => obj.context && obj.context.to && obj.context.from)
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
